:where(.button) {
  -webkit-user-select: text;
          user-select: text;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
  box-shadow: none;
  text-decoration: none;
  border-radius: var(--dds-border-radius-button);
  border: 1px solid;

  @media (prefers-reduced-motion: no-preference) {
    transition: all var(--dds-motion-micro-state);
  }

  &:active:enabled {
    scale: 0.95;
  }
}

.button--is-loading {
  cursor: not-allowed;
}

.button--full-width {
  width: 100%;
  justify-content: space-between;

  &.button--is-loading,
  &.just-icon,
  &.just-text {
    justify-content: center;
  }

  &.with-text-and-icon.with-icon-left {
    justify-content: left;
  }
}

.button--xsmall {
  min-height: var(--dds-size-height-input-xsmall);
  padding-block: var(--dds-spacing-x0-125);
  &.just-text {
    padding-inline: var(--dds-spacing-x0-5);
  }

  &.with-text-and-icon {
    gap: var(--dds-spacing-xs-icon-text-gap);

    &.with-icon-left {
      padding-inline: var(--dds-spacing-x0-25) var(--dds-spacing-x0-5);
    }
    &.with-icon-right {
      padding-inline: var(--dds-spacing-x0-5) var(--dds-spacing-x0-25);
    }
  }

  &.just-icon,
  &.button--is-loading.no-content {
    padding-inline: var(--dds-spacing-x0-25);
  }

  &.clear {
    min-height: fit-content;
    padding: var(--dds-spacing-x0-125);
  }
}

.button--small {
  min-height: var(--dds-size-height-input-small);
  padding-block: var(--dds-spacing-x0-25);
  &.just-text {
    padding-inline: var(--dds-spacing-x0-75);
  }

  &.with-text-and-icon {
    gap: var(--dds-spacing-sm-icon-text-gap);

    &.with-icon-left {
      padding-inline: var(--dds-spacing-x0-5) var(--dds-spacing-x0-75);
    }
    &.with-icon-right {
      padding-inline: var(--dds-spacing-x0-75) var(--dds-spacing-x0-5);
    }
  }

  &.just-icon,
  &.button--is-loading.no-content {
    padding-inline: var(--dds-spacing-x0-5);
  }

  &.clear {
    min-height: var(--dds-size-height-input-xsmall);
    padding: var(--dds-spacing-x0-25);
  }
}

.button--medium {
  min-height: var(--dds-size-height-input-medium);
  padding-block: var(--dds-spacing-x0-5);
  &.just-text {
    padding-inline: var(--dds-spacing-x1);
  }

  &.with-text-and-icon {
    gap: var(--dds-spacing-md-icon-text-gap);

    &.with-icon-left {
      padding-inline: var(--dds-spacing-x0-75) var(--dds-spacing-x1);
    }
    &.with-icon-right {
      padding-inline: var(--dds-spacing-x1) var(--dds-spacing-x0-75);
    }
  }

  &.just-icon,
  &.button--is-loading.no-content {
    padding-inline: var(--dds-spacing-x0-75);
  }

  &.clear {
    min-height: var(--dds-size-height-input-small);
    padding: var(--dds-spacing-x0-5);
  }
}

.button--large {
  min-height: var(--dds-size-height-input-large);
  padding-block: var(--dds-spacing-x0-75);
  &.just-text {
    padding-inline: var(--dds-spacing-x1-5);
  }

  &.with-text-and-icon {
    gap: var(--dds-spacing-lg-icon-text-gap);

    &.with-icon-left {
      padding-inline: var(--dds-spacing-x1) var(--dds-spacing-x1-5);
    }
    &.with-icon-right {
      padding-inline: var(--dds-spacing-x1-5) var(--dds-spacing-x1);
    }
  }

  &.just-icon,
  &.button--is-loading.no-content {
    padding-inline: var(--dds-spacing-x1);
  }

  &.clear {
    min-height: var(--dds-size-height-input-medium);
    padding: var(--dds-spacing-x0-75);
  }
}

.spinner-wrapper--absolute {
  position: absolute;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button--primary {
  background-color: var(--dds-color-surface-action-resting);
  border-color: var(--dds-color-surface-action-resting);
  color: var(--dds-color-text-on-action);
  &:hover:not(.button--is-loading) {
    background-color: var(--dds-color-surface-action-hover);
    border-color: var(--dds-color-surface-action-hover);
    color: var(--dds-color-text-on-action);
  }
}

.button--secondary {
  background-color: var(--dds-color-surface-default);
  border-color: var(--dds-color-border-default);
  color: var(--dds-color-text-default);

  &:hover:not(.button--is-loading) {
    background-color: var(--dds-color-surface-hover-default);
    border-color: var(--dds-color-border-action-hover);
    color: var(--dds-color-text-default);
  }
}

.button--tertiary {
  background-color: transparent;
  border-color: transparent;
  color: var(--dds-color-text-default);

  &:hover:not(.button--is-loading) {
    background-color: var(--dds-color-surface-hover-default);
    border-color: transparent;
    color: var(--dds-color-text-default);
  }
}

.button--danger {
  background-color: var(--dds-color-surface-action-danger-resting);
  border-color: var(--dds-color-surface-action-danger-resting);
  color: var(--dds-color-text-on-action);
  &:hover:not(.button--is-loading) {
    background-color: var(--dds-color-surface-action-danger-hover);
    border-color: var(--dds-color-surface-action-danger-hover);
    color: var(--dds-color-text-on-action);
  }
}
